import {Injectable, EventEmitter} from "@angular/core";
import {Login} from "../shared/Login";
import {ApplicationItem} from "../shared/ApplicationItem";
import {SelectItem} from "primeng/primeng";
import {AppPendingApplications} from "../shared/AppPendingApplications";
import {ONLINE_APP_CONSTANTS} from "../common/constant/OnlineAppConstants";

@Injectable()
export class CommonService {

  hideApplicationHeader = new EventEmitter<number>();

  showSuccessApplication(programId){
    this.hideApplicationHeader.emit(programId);
  }

  getYearList(): any
  {
    var curY:number = new Date().getFullYear();

    var yearList = [];
    yearList.push({label: 'Select Year', value: null});

    for(let cnt = curY; cnt > 1967; --cnt)
    {
      yearList.push({label: cnt.toString(), value: cnt.toString()});
    }

    return yearList;
  }
  getPastAndFutureYearList(noOfFutureYear:number): any
  {
    var startY:number = new Date().getFullYear();
    startY += noOfFutureYear;

    var yearList = [];
    yearList.push({label: 'Select Year', value: null});

    for(let cnt = startY; cnt > 1967; --cnt)
    {
      yearList.push({label: cnt.toString(), value: cnt.toString()});
    }

    return yearList;
  }
  getCreditCardYearList(): any
  {
    var curY:number = new Date().getFullYear();

    var yearList = [];
    yearList.push({label: 'Select Year', value: null});

    for(let cnt = curY; cnt < curY+10; ++cnt)
    {
      yearList.push({label: cnt.toString(), value: cnt.toString()});
    }

    return yearList;
  }
  getMonthList():any
  {
    var monthList = [];
    monthList.push({label: 'Select Month', value: null});
    monthList.push({label: 'January', value: '1'});
    monthList.push({label: 'February', value: '2'});
    monthList.push({label: 'March', value: '3'});
    monthList.push({label: 'April', value: '4'});
    monthList.push({label: 'May', value: '5'});
    monthList.push({label: 'June', value: '6'});
    monthList.push({label: 'July', value: '7'});
    monthList.push({label: 'August', value: '8'});
    monthList.push({label: 'September', value: '9'});
    monthList.push({label: 'October', value: '10'});
    monthList.push({label: 'November', value: '11'});
    monthList.push({label: 'December', value: '12'});
    return monthList;
  }



  getItem(key: string, defaultValue?: any): any {
    if (localStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key)) {
      return JSON.parse(localStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key));
    } else {
      return defaultValue;
    }
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(ONLINE_APP_CONSTANTS.APP_KEY + key, JSON.stringify(value));
  }

  /** convert kb to other type
   * @param kb
   * @param convertType
   * @returns {number}
   */
  static convertKBToOtherType(kb : number, convertType : string) : number{
    let result : number;
    switch (convertType) {
      case 'gb' :
        result = kb / (1000 * 1000);
        break;
      case  'mb' :
        result = kb / 1000;
        break;
      case  'bytes' :
        result = kb * 1000;
        break;
      default :
        result = kb;
    }
    return result;
  }
  /*
   panelIndex = new EventEmitter<number>();
   programTrack:string = "";
   //loginId: number;

   // get user details
   //loginUser: Login;
   // Open Application
   applicationItem: ApplicationItem;

   activeIndex: number = 0;

   onContinueService(panelIndexValue: number) {
   this.activeIndex = panelIndexValue;
   this.panelIndex.emit(panelIndexValue);
   }

   onPreviousService(panelIndexValue: number) {
   this.activeIndex = panelIndexValue;
   this.panelIndex.emit(panelIndexValue);
   }

   setProgramTrack(value: string) {
   this.programTrack = value;
   }
   */

  generateAppPendingRedirectPath(appPendingApplications:AppPendingApplications):any{
    let redirectURL = "";
    if(appPendingApplications != null){
      if(appPendingApplications.current_view !=null){
        let currentView = appPendingApplications.current_view;
        switch (currentView) {
          case ONLINE_APP_CONSTANTS.COM_CONTACT_INFO:
            //Contact Info
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_CONTACT_INFO;
            else
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_CONTACT_INFO;
            break;
          case ONLINE_APP_CONSTANTS.COM_PERSONAL_INFO:
            //Personal Info
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_INFO;
            else
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_INFO;
            break;
          case ONLINE_APP_CONSTANTS.COM_BACKGROUND_INFO:
            //Background Info
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_BACKGROUND_INFO;
            else
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_BACKGROUND_INFO;
            break;
          case ONLINE_APP_CONSTANTS.COM_ADMISSION_STATUS:
            //Admission Status
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_ADMISSION_STATUS;
            else
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_ADMISSION_STATUS;

            break;
          case ONLINE_APP_CONSTANTS.COM_EDUCATIONAL_BACKGROUND:
            //Educational Background
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EDUCATIONAL_BACKGROUND;
            else
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_EDUCATIONAL_BACKGROUND;
            break;
          case ONLINE_APP_CONSTANTS.COM_EMPLOYMENT_RECORD:
            //Employment Record
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EMPLOYMENT_RECORD;
            }else
              redirectURL = ""; // MLS does not have Employment Record page
            break;
          case ONLINE_APP_CONSTANTS.COM_PERSONAL_STATEMENT:
            //Personal Statement
            if (appPendingApplications.programId == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_STATEMENT;
            }else {
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_STATEMENT;
            }
            break;
          case ONLINE_APP_CONSTANTS.COM_FAITH_STATEMENT:
          case ONLINE_APP_CONSTANTS.COM_STANDARDS_SIGNATURE:
              redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_STATEMENT;
          break;
          // case "billing":
          //   //Payment Info
          //   if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
          //     routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PAYMENT_INFO;
          //     this.setActiveIndex(8);
          //   }
          //   else
          //     routePath = ""; // MLS does not have Payment Info page
          //   break;
          default:
            redirectURL = "";
        }
      }
    }
    if(redirectURL != ""){
      redirectURL = ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION + redirectURL;
    }
    return redirectURL;
  }

  removeItem(key: string): void {
    localStorage.removeItem(ONLINE_APP_CONSTANTS.APP_KEY + key);
  }

  removeSessionItem(key: string): void {
    sessionStorage.removeItem(ONLINE_APP_CONSTANTS.APP_KEY + key);
  }

  removeLoginDetail(): void{
    this.removeItem('userId');
    this.removeSessionItem('userId');
    this.removeItem('loginUser');
    this.removeItem('programTrack');
    this.removeItem('activeIndex');
    this.removeItem('applicationId');
    this.removeItem('Authorization');
    this.removeItem('isRemember');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts